import { atom } from 'jotai';

/** Session ids hidden from Start Now after Stop, until a failed save restores Start. */
export const startNowStoppedSessionIdsAtom = atom<ReadonlySet<string>>(new Set<string>());

export function addStartNowStoppedSessionId(
  sessionIds: ReadonlySet<string>,
  sessionId: string
): ReadonlySet<string> {
  if (sessionIds.has(sessionId)) return sessionIds;
  const next = new Set(sessionIds);
  next.add(sessionId);
  return next;
}

export function removeStartNowStoppedSessionId(
  sessionIds: ReadonlySet<string>,
  sessionId: string
): ReadonlySet<string> {
  if (!sessionIds.has(sessionId)) return sessionIds;
  const next = new Set(sessionIds);
  next.delete(sessionId);
  return next;
}
